  import { Injectable } from "@angular/core";
  import { HttpClient } from "@angular/common/http";
  import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
  import { environment } from "src/environments/environment.prod";
  import { map } from 'rxjs/operators';
  import { EventType, PublicClientApplication, RedirectRequest } from "@azure/msal-browser";
  import { BehaviorSubject, Observable } from "rxjs";
  import { User } from "../interface/user";
  import { HttpService } from "./http.service";
  import { privateDecrypt } from "crypto";
  import { TokenService } from "./token.service";
  import { Router } from "@angular/router";
  import { isNullOrUndefined } from "util";
  import { JwtHelperService } from "@auth0/angular-jwt";


  @Injectable({
      providedIn: 'root'
  })
  export class AuthService {
      constructor(
        private router: Router,
        private msalService: MsalService,
        private httpService: HttpService,
        private tokenService: TokenService,
        private jwtHelper: JwtHelperService
      ) {}

      login() {
        const loginRequest: RedirectRequest = {
          scopes: [`api://${environment.clienteId}/user_impersonation`],
          prompt: "select_account"
        };
        this.msalService.loginRedirect(loginRequest);
      }

      authenticate(authCodeRequest: any): Observable<boolean> {
        return this.httpService.postUsuario(authCodeRequest).pipe(
            map(res => {
              console.log(res);
              if (res) {
                console.log(res)
                  this.httpService.setLoggedIn(true, res.token)
                  this.tokenService.setToken('usuario', JSON.stringify(res));
                  return true
              } 
              return false;
            })
        );
     }
    
      logout() {
        this.httpService.flushToken();
        this.tokenService.removeToken('usuario');
        this.tokenService.flush();
        sessionStorage.clear();
        this.router.navigateByUrl('/login')
      }

      public isAuthenticated(): boolean {
        const token: string = this.tokenService.getToken('usuario');

        if (isNullOrUndefined(token) || token.length === 0) 
            return false;

        return !this.jwtHelper.isTokenExpired(token);
      }
    
      getCodeVerifier()
      {
        const requestParams = sessionStorage.getItem(`msal.${environment.clienteId}.request.params`);
        const decodedParams = JSON.parse(atob(requestParams));
        const codeVerifier = decodedParams.codeVerifier;
        return codeVerifier;
      }
  }